import React from "react";
import PageCover from "../../Components/Shared/PageCover";
import team from "../../Components/Assets/Images/teamCover.jpg";
import ManagementTeam from "./ManagementTeam";
import PilotsTeam from "./PilotsTeam";
import CabinCrewTeam from "./CabinCrewTeam";
import { motion } from "framer-motion";

const OurTeam = () => {
  return (
    <>
      <motion.div
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ x: 100, opacity: 0 }}
        transition={{ duration: 1, ease: "easeInOut" }}
        viewport={{ once: false, amount: 0.5 }}
      >
        <PageCover
          title="Our Team"
          subtitle="Welcome to Our World, Where Innovation Meets Purpose, and Possibilities Unfold."
          image={team}
        />
      </motion.div>
      <motion.div
        initial={{ x: 100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        exit={{ x: 100, opacity: 0 }}
        transition={{ duration: 1, ease: "easeInOut" }}
        viewport={{ once: true, amount: 0.01 }}
      >
        <ManagementTeam />
      </motion.div>
      <motion.div
        initial={{ x: -100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        exit={{ x: 100, opacity: 0 }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
        viewport={{ once: false, amount: 0.1 }}
      >
        {/* <PilotsTeam /> */}
      </motion.div>
      <motion.div
        initial={{ x: 100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        exit={{ x: 100, opacity: 0 }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
        viewport={{ once: false, amount: 0.1 }}
      >
        {/* <CabinCrewTeam /> */}
      </motion.div>
    </>
  );
};

export default OurTeam;
